import { Link } from 'react-router-dom'

import Title from './Title'
import LinkButton from '../items/LinkButton'
import Technology from './Technology'
import gitHub from '../../img/gitHub.png'
import site from '../../img/internet.png'

import styles from './cardProject.module.css'

export default function CardProject({
  name,
  img,
  text,
  app,
  repo,
  technology1,
  nameTechnology1,
  technology2,
  nameTechnology2,
  technology3,
  nameTechnology3,
  technology4,
  nameTechnology4
}) {
  return (
    <div className={styles.container}>
      <Title title="Projeto" subTitle={name} />
      <div className={styles.project}>
        <div className={styles.left}>
          <div className={styles.projectCard}>
            <img
              src={img}
              alt={`Imagem do projeto ${name}`}
              className={styles.img}
            />
          </div>
          <div className={styles.containerTechnology}>
            {technology1 ? (
              <Technology img={technology1} name={nameTechnology1} />
            ) : (
              ''
            )}
            {technology2 ? (
              <Technology img={technology2} name={nameTechnology2} />
            ) : (
              ''
            )}
            {technology3 ? (
              <Technology img={technology3} name={nameTechnology3} />
            ) : (
              ''
            )}
            {technology4 ? (
              <Technology img={technology4} name={nameTechnology4} />
            ) : (
              ''
            )}
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.about}>
            <Title title="Sobre o" subTitle={name} />
          </div>
          <h3>{text}</h3>
          <div className={styles.containerLinks}>
            <div className={styles.containerLink}>
              <a href={app} target="_blank">
                <div className={styles.link}>
                  <img src={site} alt="link Site" />
                </div>
              </a>
            </div>
            <a href={app} target="_blank">
              <LinkButton text="Visite o site" />
            </a>
          </div>
          <div className={styles.containerLinks}>
            <div className={styles.containerLink}>
              <a href={repo} target="_blank">
                <div className={styles.link}>
                  <img src={gitHub} alt="link GitHub" />
                </div>
              </a>
            </div>
            <a href={repo} target="_blank">
              <LinkButton
                text={repo ? 'Visite o repositório' : 'Respositorio privado'}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
